'use client'

import { BaseHubImage as Image } from 'basehub/next-image'
import { CustomerFragment } from '../../fragments'
import Marquee from 'react-fast-marquee'
import { useMedia } from '~/hooks/use-media'
import { clsx } from 'clsx'

export const Customers = ({
  title = 'Used by',
  customers,
  height,
  width,
  className,
}: {
  title?: string
  customers: CustomerFragment[]
  height?: number
  width?: number
  className?: string
}) => {
  const enableCarousel = useMedia('(min-width: 540px)')
  const logoWidth = width ?? 94

  return (
    <div
      className={clsx(
        'flex items-center left-1/2 relative -translate-x-1/2 w-screen sm:w-auto sm:translate-x-[unset] sm:left-[unset]',
        className
      )}
    >
      <p className="relative z-[1] text-center text-xs tracking-tighter leading-normal text-dark-faint hidden sm:block whitespace-nowrap mr-3 ml-4 mb-2">
        {title}
      </p>
      <ul className="relative z-[1] flex flex-wrap justify-center items-center -space-x-6">
        <Marquee
          gradient={!enableCarousel}
          gradientColor="#040404"
          play={!enableCarousel}
          key={enableCarousel ? 'desktop' : 'mobile'}
        >
          {customers.map((customer) => {
            return (
              <li key={customer._id}>
                <Image
                  style={{ width: logoWidth }}
                  priority
                  src={customer.image.url}
                  alt={customer.image.alt ?? ''}
                  height={height ?? customer.image.height * 1.5}
                  width={width ?? customer.image.width * 1.5}
                  quality={100}
                  className="select-none object-contain h-9"
                />
              </li>
            )
          })}
        </Marquee>
      </ul>
    </div>
  )
}
